export default __webpack_public_path__ + "static/media/32.767ae125.jpg";